import { OperationResultType } from '@/app/constants/operationResultType'

// `type` is the OperationResultType enum: numeric from SuperTacho.Api
// (Newtonsoft serializes enums as numbers), a name from some other endpoints.
const isErrorRecord = (record: any): boolean => {
  const typeValue = record?.type ?? record?.Type
  if (typeof typeValue === 'number') {
    return typeValue === OperationResultType.Error
  }
  if (typeof typeValue === 'string') return typeValue.toLowerCase() === 'error'
  return false
}

const getMessageFromJsonPayload = (payload: unknown): string | undefined => {
  if (Array.isArray(payload) && payload.length > 0) {
    const item = payload.find(isErrorRecord) || payload[0]

    return getMessageFromJsonPayload(item)
  }

  if (payload && typeof payload === 'object') {
    const msg = (payload as any).message || (payload as any).Message || (payload as any).title || (payload as any).Title
    if (typeof msg === 'string' && msg.length > 0) {
      return msg
    }
  }

  if (typeof payload === 'string' && payload.length > 0) {
    return payload
  }

  return undefined
}

const parseEmbeddedJsonMessage = (message: string): string | undefined => {
  const jsonStartCandidates = [message.indexOf('{'), message.indexOf('[')].filter(
    (index) => index >= 0,
  )
  if (jsonStartCandidates.length === 0) {
    return undefined
  }

  const jsonStart = Math.min(...jsonStartCandidates)
  const jsonCandidate = message.slice(jsonStart).trim()

  try {
    const parsedPayload = JSON.parse(jsonCandidate)
    return getMessageFromJsonPayload(parsedPayload)
  } catch {
    return undefined
  }
}

const normalizeApiErrorMessage = (message: string | undefined): string | undefined => {
  if (!message) {
    return message
  }

  return parseEmbeddedJsonMessage(message) || message
}

export const getApiErrorMessage = (err: any): string | undefined => {
  const data = err?.response?.data

  if (Array.isArray(data) && data.length > 0) {
    const item = data.find(isErrorRecord) || data[0]
    const message = getMessageFromJsonPayload(item)
    if (message) return normalizeApiErrorMessage(message)
  }

  if (data && typeof data === 'object') {
    const message = getMessageFromJsonPayload(data)
    if (message) return normalizeApiErrorMessage(message)
  }

  if (typeof data === 'string' && data.length > 0) {
    return normalizeApiErrorMessage(data)
  }

  return normalizeApiErrorMessage(err?.message)
}
